import { gql } from "@apollo/client"
import { useQuery } from "@apollo/client"
import { GridColDef } from "@mui/x-data-grid"
import { useEffect, useMemo, useState } from "react"
import { useParams } from "react-router"
import { Box, Chip } from "@mui/material"
// import { SimpleToolbar, Table } from "../../../../components/Table"
import { TableStandard, TableToolBar } from "ui"
import { LoadingWrapper } from "../../../../components/LoadingWrapper"

// const GET_KEYWORD_ANSWERS = gql`
// query GetKeywordAnswersForSession ($sessionId:UUID!){
//   keywordAnswersForSession(sessionId:$sessionId){
//     id
//     createdAt
//     question {
//       position
//       title
//     }
//     data
//     keyWordExtractionData
//   }
// }`
const GET_KEYWORD_ANSWERS = gql`
query GetKeywordAnswersForSession ($sessionId:UUID!){
  keywordAnswersForSession(sessionId:$sessionId){
    id
    createdAt
    question {
      position
      title
    }
    data
    answerCategories{
      id
      keywordId
      keyword{
        id
        wordOrPhrase
      }
    }
    }
  }`
const mapTableData = (data: any) => {
    const _answerData = JSON.parse(data.data).data
    // const _keywordData = JSON.parse(data.keyWordExtractionData).data
    //NOTE REMOVING THE REASON IT WAS FLAGGED ON 06-05-2026
    return {
        id: data.id,
        answerData: _answerData,
        // keywordData: _keywordData,
        questionTitle: data.question.title,
        questionPosition: data.question.position
    }
}
export default function KeywordTable({
    onBack
}: { onBack: () => void }) {
    const { sessionId } = useParams()
    const [rows, setRows] = useState<any[]>([])
    const { data, loading, error } = useQuery(GET_KEYWORD_ANSWERS, {
        variables: {
            sessionId: sessionId
        }
    })
    useEffect(() => {
        if (!data) return;
        const rows = data?.keywordAnswersForSession.map(mapTableData)
        setRows(rows ?? [])
    }, [loading, data])
    // useEffect(() => {
    //     console.log("rows: ", rows)

    // }, [rows])
    const columns = useMemo((): GridColDef[] => {
        return [
            {
                field: "questionTitle", headerName: "Question",
                sortable: false, flex: 1,

                editable: false,
                renderCell: (params) => (
                    <div style={{ whiteSpace: "break-spaces", textAlign: "start", lineHeight: 1, justifyContent: "center", width: "100%" }}>{params.value}</div>
                )
            },
            {
                field: "answerData", headerName: "Response",
                sortable: false, flex: 2,
                renderCell: (params) => (
                    <Box
                        sx={{
                            width: "100%",
                            whiteSpace: "normal",  // allow wrapping
                            wordBreak: "break-word", // break long words
                            overflowWrap: "break-word",
                            lineHeight: 1.5
                        }}
                    >
                        {params.value}
                    </Box>)
            },
            // { field: "keywordData", headerName: "Keyword", flex: 1 },
            // {
            //     field: "keywordCategory", headerName: "Keyword Category", flex: 1,
            //     renderCell: (params) => {
            //         return (
            //             <>
            //                 {
            //                     params.row.keywordCategory.map((category: string, index: number) => (
            //                         <Chip key={index} label={category} size="small" style={{ marginTop: 1 }} />
            //                     ))
            //                 }
            //             </>
            //         )
            //     }
            // }
        ]
    }, [])

    return (
        <LoadingWrapper loading={loading} sx={{ marginTop: 4 }}>
            <Box component="div" sx={{ background: "#fff", paddingTop: 1, marginTop: 1, marginBottom: 8 }}>
                <TableStandard
                    loading={loading}
                    rows={rows}
                    columns={columns}
                    pageSize={100}
                    disableBoxShadow={false}
                    renderToolbar={(props: any) => {
                        return (
                            <Box component="div" sx={{ paddingBottom: 1 }}>
                                <TableToolBar title={`Responses Needing Review`} onBack={onBack}  {...props} />
                            </Box>)
                    }}
                    isRowSelectable={() => false}
                    slots={{}}
                    selectionProps={{}}
                    onRowSelectionModelChange={() => { }}
                />

            </Box>
        </LoadingWrapper>
    )
}